import { Route } from '@angular/router';

import { authGuard } from './core/auth/guards/auth.guard';
import { loggedInRedirectGuard } from './core/auth/guards/logged-in-redirect.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    children: [
      {
        path: 'login',
        title: 'Feature Flags',
        canActivate: [loggedInRedirectGuard],
        loadComponent: () => import('./features/login-page/login-page.component').then(m => m.LoginPageComponent),
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    loadComponent: () => import('./shell/shell.component').then(m => m.ShellComponent),
    children: [
      {
        path: '',
        redirectTo: 'uebersicht',
        pathMatch: 'full',
      },
      {
        path: 'uebersicht',
        title: 'Feature Flags',
        loadComponent: () => import('./features/overview/overview.component').then(m => m.OverviewComponent),
      },
      {
        path: 'audit-log',
        title: 'Feature Flags – Audit-Log',
        loadComponent: () => import('./features/audit-log/audit-log.component').then(m => m.AuditLogComponent),
      },
    ],
  },
];
